import { useState } from 'react';
import { toast } from 'react-toastify';
import { deleteData } from '../../../DataAccessLayer';
import { flashcards } from '../../../DataAccessLayer/services';

// Owns the confirm-delete state machine for the deck edit page: which deck
// (if any) is pending confirmation, the delete call itself, and the
// loading/toast feedback around it. Callers only need to render the
// confirmation modal and say what happens once the deck is actually gone
// (navigate away, etc).
function useDeleteFlashcardDeck({ courseId, onDeleted }) {
  const [deckToDelete, setDeckToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const promptDelete = (deck) => setDeckToDelete(deck);
  const cancelDelete = () => setDeckToDelete(null);

  const deleteDeck = async () => {
    const deck = deckToDelete;
    setIsDeleting(true);
    setDeckToDelete(null);
    try {
      await deleteData(flashcards({ id: deck.id, courseId }));
      toast.success('Flashcard deck deleted successfully.');
      onDeleted?.(deck);
    } catch (err) {
      console.log(err);
      toast.error('Failed to delete flashcard deck. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  return { deckToDelete, isDeleting, promptDelete, cancelDelete, deleteDeck };
}

export default useDeleteFlashcardDeck;
